export default __webpack_public_path__ + "static/media/1.4b52db15.jpg";